var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1529_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.34619,
    width: 47.9236,
    height: 47.3462,
    rx: 11.4331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1529_10375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5319 37.0511C16.7898 35.4563 17.0846 33.5004 17.4346 31.5506C17.539 30.9608 17.4101 30.5576 16.9679 30.1484C15.7643 29.035 14.6037 27.8735 13.4247 26.7301C13.3387 26.6459 13.2404 26.5736 13.1667 26.4834C12.4298 25.6348 11.7359 24.7321 12.0982 23.5345C12.4667 22.3189 13.5659 21.9397 14.6835 21.7411C16.4337 21.4222 18.19 21.1694 19.9524 20.9287C20.4928 20.8565 20.7937 20.6218 21.0148 20.1403C21.678 18.684 22.3903 17.2517 23.0842 15.8073C23.1641 15.6449 23.2377 15.4884 23.3237 15.3319C23.8764 14.3389 24.5089 13.4001 25.7862 13.346C27.0389 13.2918 27.6407 14.2427 28.1443 15.1514C29.0224 16.7281 29.8392 18.347 30.6252 19.9718C30.9077 20.5556 31.27 20.7903 31.9148 20.8625C33.5298 21.037 35.1326 21.3018 36.7476 21.5245C36.7783 21.5245 36.809 21.5305 36.8397 21.5365C37.9819 21.7712 39.1548 22.03 39.6093 23.2457C40.0821 24.5034 39.3821 25.4844 38.553 26.345C37.331 27.6087 36.0783 28.8485 34.8194 30.0822C34.4509 30.4433 34.2913 30.7622 34.408 31.3219C34.758 32.9708 35.0036 34.6378 35.2922 36.2928C35.3107 36.4071 35.3475 36.5215 35.3598 36.6418C35.4703 37.7853 35.5317 38.9648 34.4387 39.705C33.3947 40.4212 32.2894 40.0481 31.27 39.5426C29.7102 38.7662 28.1688 37.9598 26.6398 37.1293C26.1608 36.8705 25.7985 36.8705 25.3195 37.1413C23.9132 37.9417 22.4763 38.688 21.0455 39.4523C20.7814 39.5907 20.5112 39.7291 20.2349 39.8435C17.9996 40.7582 16.5196 39.7833 16.5442 37.0511H16.5319Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3163 41.2339C28.4882 40.1567 28.6909 38.8327 28.9304 37.5208C29.004 37.1236 28.9119 36.8528 28.6172 36.5699C27.8066 35.8177 27.0205 35.0293 26.2222 34.259C26.167 34.2048 26.0994 34.1507 26.0442 34.0905C25.5467 33.5188 25.0739 32.9049 25.3195 32.0985C25.5713 31.2801 26.3143 31.0213 27.0697 30.8829C28.2487 30.6662 29.44 30.4977 30.6252 30.3352C30.9937 30.2871 31.1963 30.1306 31.3437 29.7996C31.792 28.8187 32.271 27.8498 32.7438 26.8748C32.793 26.7665 32.8482 26.6582 32.9035 26.5499C33.2719 25.8819 33.7018 25.25 34.5615 25.2139C35.409 25.1777 35.8143 25.8217 36.1581 26.4355C36.7538 27.5007 37.3065 28.596 37.8346 29.6913C38.025 30.0825 38.2706 30.2449 38.7066 30.2931C39.7997 30.4135 40.8805 30.588 41.9674 30.7384C41.9858 30.7384 42.0104 30.7384 42.0288 30.7444C42.8025 30.9009 43.5886 31.0815 43.8956 31.8999C44.2149 32.7485 43.7421 33.4104 43.1833 33.9942C42.3543 34.8488 41.513 35.6853 40.6594 36.5158C40.4138 36.7565 40.3032 36.9731 40.3831 37.3523C40.6164 38.4656 40.7883 39.591 40.9787 40.7103C40.991 40.7886 41.0156 40.8668 41.0217 40.945C41.0954 41.7154 41.1384 42.5097 40.4015 43.0153C39.6953 43.4967 38.9461 43.25 38.2583 42.9009C37.2082 42.3773 36.1643 41.8357 35.1326 41.27C34.8072 41.0955 34.5615 41.0955 34.2422 41.276C33.2904 41.8177 32.3201 42.3232 31.356 42.8347C31.1779 42.931 30.9937 43.0213 30.8095 43.0995C29.2988 43.7134 28.304 43.0574 28.3163 41.2159V41.2339Z",
    fill: "#AB54A2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1529_10375",
    x: 0.57006,
    y: 0.916251,
    width: 59.3567,
    height: 58.7793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28663,
    dy: 2.28663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.403922 0 0 0 0 0.517647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1529_10375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1529_10375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1529_10375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30,
    fill: "white",
    transform: "translate(12 13.3462)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleStarIcon);
export default __webpack_public_path__ + "static/media/double-star-icon.606a9d77a1063359dc23f5d9d782f425.svg";
export { ForwardRef as ReactComponent };